export function when(ts?: string): string {
  return ts ? new Date(ts).toLocaleString() : '—';
}

export function parseOrigins(text: string): string[] {
  return text
    .split(/[\s,]+/)
    .map((o) => o.trim())
    .filter(Boolean);
}
